import { render, staticRenderFns } from "./basic-info.html?vue&type=template&id=54afaa80&scoped=true&external"
import script from "./basic-info.js?vue&type=script&lang=js&external"
export * from "./basic-info.js?vue&type=script&lang=js&external"
import style0 from "./basic-info.scss?vue&type=style&index=0&id=54afaa80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afaa80",
  null
  
)

export default component.exports